import React from 'react';
import _ from 'lodash';
import {Divider, IconButton, Link, Stack, styled, Typography, useTheme} from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MailIcon from '@mui/icons-material/MailOutline';
import {qw} from '../util.js';
import {SOCIALS, whatsAppLink} from '../util/social.js';
import SITEMAP from '../sitemap.js';
// import TikTokIcon from './TiktokIcon.js';

const SOCIAL_ICONS = [{
    id: 'instagram',
    IconComp: InstagramIcon,
    link: SOCIALS.INSTAGRAM,
// }, {
//     id: 'tiktok',
//     IconComp: TikTokIcon,
//     link: SOCIALS.TIKTOK,
}, {
    id: 'whatsapp',
    IconComp: WhatsAppIcon,
    link: whatsAppLink(),
}, {
    id: 'mail',
    IconComp: MailIcon,
    link: `mailto:${SOCIALS.EMAIL}`,
}];

const BOTTOM_LINKS = _.entries(_.pick(SITEMAP, qw`/terms /privacy-policy /accessibility`))
    .map(([url, {title}])=>({url, text: title}));

const DividedLinks = ()=><Stack direction="row" gap="10px" justifyContent="center">
  {BOTTOM_LINKS.map(({url, text}, i)=><React.Fragment key={i}>
    {i!=0&&<Divider orientation="vertical" variant="middle" flexItem/>}
    <Link color="primary.main" sx={{':hover': {color: 'primary.light'}}} href={url}>{text}</Link>
  </React.Fragment>)}
</Stack>;

const SocialIcons = ()=>{
    let theme = useTheme();
    return <Stack direction="row" justifyContent="center">
      {SOCIAL_ICONS.map(({IconComp, link, id})=><IconButton
        key={id}
        onClick={()=>window.open(link)}
        sx={{
            color: theme.palette.primary.main,
            ':hover': {color: theme.palette.primary.light},
        }}>
        <IconComp/>
      </IconButton>)}
    </Stack>;
};

const FooterContainer = styled(props=>{
    let {children, ...rest} = props;
    return <Stack direction="column"
      spacing={1}
      padding={4}
      {...rest}>
      {children}
    </Stack>;
})`
    background-color: ${p=>p.theme.palette.background.dark};
    color: ${p=>p.theme.palette.primary.contrastText};
`;

const Footer = props=>{
    let {footerMargin=0} = props;
    return <FooterContainer marginTop={footerMargin}>
      <Stack direction="column" justifyContent="center" alignItems="center" gap={2}>
        <Typography variant="body2" textAlign="center">
          חלק מהטקסטים נכתבו בלשון נקבה - אבל השירותים מיועדים באהבה לכולם.ן
        </Typography>
        <Typography fontStyle="italic" textAlign="center">
          אני מברכת אתכם באור ובאהבה של היוצר האינסופי 🌸
        </Typography>
      </Stack>
      <DividedLinks/>
      <SocialIcons/>
      <Typography variant="body2" color="primary.contrastText" align="center">
        {'כל הזכויות שמורות © '}
        <Link color="primary.contrastText" sx={{':hover': {color: 'primary.light'}}} href="/">
          סימונה צ'רי
        </Link>{' '}
        {new Date().getFullYear()}
      </Typography>
    </FooterContainer>;
};

export default Footer;
